/** Graphic sticker pack for header GIF builder (not emoji). */

export type StickerKind = {
  id: string;
  label: string;
  /** viewBox size; stickers are square-ish */
  size: number;
  svg: string;
};

function wrap(size: number, body: string) {
  return `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}" fill="none">${body}</svg>`;
}

export const HEADER_STICKERS: StickerKind[] = [
  {
    id: 'arrow-bold',
    label: 'فلش درشت',
    size: 128,
    svg: wrap(
      128,
      `<path d="M18 64h72" stroke="#fff" stroke-width="14" stroke-linecap="round"/>
       <path d="M70 28l40 36-40 36" stroke="#FF5C7A" stroke-width="14" stroke-linecap="round" stroke-linejoin="round"/>
       <path d="M18 64h72" stroke="#FF5C7A" stroke-width="8" stroke-linecap="round"/>`,
    ),
  },
  {
    id: 'arrow-curve',
    label: 'فلش خمیده',
    size: 128,
    svg: wrap(
      128,
      `<path d="M24 96c8-48 40-72 80-72" stroke="#fff" stroke-width="12" stroke-linecap="round" fill="none"/>
       <path d="M24 96c8-48 40-72 80-72" stroke="#F5C542" stroke-width="7" stroke-linecap="round" fill="none"/>
       <path d="M88 18l20 10-14 20" stroke="#F5C542" stroke-width="8" stroke-linecap="round" stroke-linejoin="round"/>`,
    ),
  },
  {
    id: 'arrow-double',
    label: 'فلش دوتایی',
    size: 128,
    svg: wrap(
      128,
      `<path d="M16 48h70M16 80h70" stroke="#fff" stroke-width="10" stroke-linecap="round"/>
       <path d="M16 48h70M16 80h70" stroke="#5EEAD4" stroke-width="6" stroke-linecap="round"/>
       <path d="M72 28l36 20-36 20M72 60l36 20-36 20" stroke="#5EEAD4" stroke-width="8" stroke-linecap="round" stroke-linejoin="round"/>`,
    ),
  },
  {
    id: 'chevron-burst',
    label: 'شورون',
    size: 128,
    svg: wrap(
      128,
      `<path d="M30 30l34 34-34 34" stroke="#fff" stroke-width="14" stroke-linecap="round" stroke-linejoin="round"/>
       <path d="M58 30l34 34-34 34" stroke="#A78BFA" stroke-width="14" stroke-linecap="round" stroke-linejoin="round"/>`,
    ),
  },
  {
    id: 'flower-rose',
    label: 'رز',
    size: 128,
    svg: wrap(
      128,
      `<circle cx="64" cy="58" r="18" fill="#E11D48"/>
       <circle cx="48" cy="48" r="14" fill="#FB7185"/>
       <circle cx="80" cy="48" r="14" fill="#FB7185"/>
       <circle cx="44" cy="68" r="13" fill="#BE123C"/>
       <circle cx="84" cy="68" r="13" fill="#BE123C"/>
       <circle cx="64" cy="72" r="12" fill="#9F1239"/>
       <circle cx="64" cy="58" r="8" fill="#FEF2F2"/>
       <path d="M64 76c-2 14-12 26-12 34M64 76c2 14 12 26 12 34" stroke="#15803D" stroke-width="6" stroke-linecap="round"/>
       <path d="M52 92c-14-2-22 8-20 16M76 92c14-2 22 8 20 16" stroke="#22C55E" stroke-width="5" stroke-linecap="round" fill="none"/>`,
    ),
  },
  {
    id: 'flower-bloom',
    label: 'شکوفه',
    size: 128,
    svg: wrap(
      128,
      `<g transform="translate(64 64)">
         <ellipse cx="0" cy="-22" rx="14" ry="20" fill="#F9A8D4" transform="rotate(0)"/>
         <ellipse cx="0" cy="-22" rx="14" ry="20" fill="#F472B6" transform="rotate(72)"/>
         <ellipse cx="0" cy="-22" rx="14" ry="20" fill="#FB7185" transform="rotate(144)"/>
         <ellipse cx="0" cy="-22" rx="14" ry="20" fill="#F472B6" transform="rotate(216)"/>
         <ellipse cx="0" cy="-22" rx="14" ry="20" fill="#F9A8D4" transform="rotate(288)"/>
         <circle r="12" fill="#FDE68A"/>
         <circle r="5" fill="#F59E0B"/>
       </g>`,
    ),
  },
  {
    id: 'flower-tulip',
    label: 'لاله',
    size: 128,
    svg: wrap(
      128,
      `<path d="M64 108V58" stroke="#16A34A" stroke-width="7" stroke-linecap="round"/>
       <path d="M64 78c-18-4-28 10-26 22" stroke="#22C55E" stroke-width="5" fill="none" stroke-linecap="round"/>
       <path d="M48 58c0-22 10-36 16-40 6 4 16 18 16 40-6-6-14-6-16 0-2-6-10-6-16 0z" fill="#EF4444"/>
       <path d="M52 54c4-14 10-24 12-28 2 4 8 14 12 28" stroke="#FCA5A5" stroke-width="3" fill="none"/>`,
    ),
  },
  {
    id: 'leaf-duo',
    label: 'برگ',
    size: 128,
    svg: wrap(
      128,
      `<path d="M30 90c8-40 34-62 70-70-6 38-28 64-70 70z" fill="#4ADE80"/>
       <path d="M34 86c20-18 40-30 62-40" stroke="#166534" stroke-width="3" stroke-linecap="round"/>
       <path d="M48 40c20-8 40 2 52 22-22 8-40 4-52-22z" fill="#86EFAC"/>`,
    ),
  },
  {
    id: 'sparkle-burst',
    label: 'درخشش',
    size: 128,
    svg: wrap(
      128,
      `<path d="M64 12l8 36 36 8-36 8-8 36-8-36-36-8 36-8z" fill="#FDE047"/>
       <path d="M64 28l5 24 24 5-24 5-5 24-5-24-24-5 24-5z" fill="#fff" opacity=".85"/>
       <circle cx="28" cy="28" r="5" fill="#FBBF24"/>
       <circle cx="100" cy="34" r="4" fill="#FDE68A"/>
       <circle cx="96" cy="96" r="6" fill="#FBBF24"/>
       <circle cx="30" cy="98" r="4" fill="#FEF08A"/>`,
    ),
  },
  {
    id: 'star-badge',
    label: 'ستاره',
    size: 128,
    svg: wrap(
      128,
      `<path d="M64 10l14 38h40L86 72l14 40-36-24-36 24 14-40L10 48h40z" fill="#F59E0B" stroke="#fff" stroke-width="4" stroke-linejoin="round"/>`,
    ),
  },
  {
    id: 'ribbon',
    label: 'روبان',
    size: 128,
    svg: wrap(
      128,
      `<path d="M20 44h88v28H20z" fill="#EC4899"/>
       <path d="M20 44l-12 18 12 18V44zm88 0l12 18-12 18V44z" fill="#BE185D"/>
       <path d="M20 52h88" stroke="#F9A8D4" stroke-width="4"/>
       <circle cx="64" cy="58" r="10" fill="#fff"/>
       <circle cx="64" cy="58" r="5" fill="#F472B6"/>`,
    ),
  },
  {
    id: 'sale-burst',
    label: 'تخفیف',
    size: 128,
    svg: wrap(
      128,
      `<circle cx="64" cy="64" r="48" fill="#EF4444" stroke="#fff" stroke-width="6"/>
       <circle cx="64" cy="64" r="38" fill="none" stroke="#FECACA" stroke-width="3" stroke-dasharray="6 6"/>
       <text x="64" y="72" text-anchor="middle" font-size="28" font-family="Tahoma,sans-serif" font-weight="800" fill="#fff">٪</text>`,
    ),
  },
  {
    id: 'heart-glow',
    label: 'قلب',
    size: 128,
    svg: wrap(
      128,
      `<path d="M64 108S20 78 20 48c0-16 12-28 28-28 10 0 18 5 16 16C62 25 70 20 80 20c16 0 28 12 28 28 0 30-44 60-44 60z" fill="#F43F5E" stroke="#fff" stroke-width="5"/>
       <path d="M40 46c4-10 14-12 20-6" stroke="#FECDD3" stroke-width="5" stroke-linecap="round" fill="none"/>`,
    ),
  },
  {
    id: 'gift-box',
    label: 'کادو',
    size: 128,
    svg: wrap(
      128,
      `<rect x="28" y="56" width="72" height="52" rx="6" fill="#6366F1" stroke="#fff" stroke-width="4"/>
       <rect x="24" y="42" width="80" height="20" rx="5" fill="#818CF8" stroke="#fff" stroke-width="4"/>
       <rect x="58" y="42" width="12" height="66" fill="#F472B6"/>
       <rect x="24" y="48" width="80" height="10" fill="#F472B6"/>
       <path d="M64 42c-10-18-28-14-28 0 14-4 22 0 28 10 6-10 14-14 28-10 0-14-18-18-28 0z" fill="#FB7185"/>`,
    ),
  },
  {
    id: 'pointer-hand',
    label: 'اشاره',
    size: 128,
    svg: wrap(
      128,
      `<path d="M54 20v44M54 20c0-8 10-8 10 0v36M64 28c0-7 10-7 10 0v32M74 34c0-6 10-6 10 0v30M84 40c0-5 9-5 9 2v28c0 18-12 30-30 30H52c-14 0-24-8-28-20l-8-18c-2-6 2-12 8-12h8" fill="#FDE68A" stroke="#fff" stroke-width="5" stroke-linejoin="round"/>`,
    ),
  },
  {
    id: 'flame',
    label: 'شعله',
    size: 128,
    svg: wrap(
      128,
      `<path d="M64 14c8 18-8 26-2 44 18-10 34 4 28 28-4 20-22 34-42 30-22-4-34-26-28-46 8 10 18 8 22-2 6-14 8-34 22-54z" fill="#F97316"/>
       <path d="M60 58c4 8-2 12 2 22 8-4 16 2 14 14-2 12-14 18-24 14-12-4-18-16-12-28 4 6 10 6 12 0 4-8 4-16 8-22z" fill="#FDE68A"/>`,
    ),
  },
  {
    id: 'crown',
    label: 'تاج',
    size: 128,
    svg: wrap(
      128,
      `<path d="M20 92l8-48 20 24 16-40 16 40 20-24 8 48H20z" fill="#F59E0B" stroke="#fff" stroke-width="5" stroke-linejoin="round"/>
       <circle cx="28" cy="42" r="7" fill="#FDE68A"/>
       <circle cx="64" cy="26" r="8" fill="#FDE68A"/>
       <circle cx="100" cy="42" r="7" fill="#FDE68A"/>
       <rect x="28" y="92" width="72" height="12" rx="3" fill="#D97706"/>`,
    ),
  },
  {
    id: 'bow',
    label: 'پاپیون',
    size: 128,
    svg: wrap(
      128,
      `<path d="M64 64L24 40c-8 20-8 36 0 48L64 64z" fill="#EC4899"/>
       <path d="M64 64l40-24c8 20 8 36 0 48L64 64z" fill="#DB2777"/>
       <circle cx="64" cy="64" r="12" fill="#F9A8D4" stroke="#fff" stroke-width="4"/>
       <path d="M64 76v28" stroke="#BE185D" stroke-width="6" stroke-linecap="round"/>`,
    ),
  },
  {
    id: 'diamond',
    label: 'الماس',
    size: 128,
    svg: wrap(
      128,
      `<path d="M64 112L16 52l20-28h56l20 28L64 112z" fill="#67E8F9" stroke="#fff" stroke-width="5" stroke-linejoin="round"/>
       <path d="M36 24l28 28 28-28M16 52h96M64 52v60" stroke="#A5F3FC" stroke-width="4"/>
       <path d="M36 24h56L64 52 36 24z" fill="#ECFEFF" opacity=".8"/>`,
    ),
  },
  {
    id: 'megaphone',
    label: 'بلندگو',
    size: 128,
    svg: wrap(
      128,
      `<path d="M28 48h20l44-20v72L48 80H28a12 12 0 010-32z" fill="#F97316" stroke="#fff" stroke-width="5" stroke-linejoin="round"/>
       <path d="M28 56h16v16H28a8 8 0 010-16z" fill="#FED7AA"/>
       <path d="M100 44c8 8 8 32 0 40M110 36c14 12 14 44 0 56" stroke="#FB923C" stroke-width="5" stroke-linecap="round"/>`,
    ),
  },
  {
    id: 'truck',
    label: 'ارسال',
    size: 128,
    svg: wrap(
      128,
      `<rect x="14" y="44" width="60" height="40" rx="6" fill="#0EA5E9" stroke="#fff" stroke-width="4"/>
       <path d="M74 56h22l14 16v12H74V56z" fill="#38BDF8" stroke="#fff" stroke-width="4" stroke-linejoin="round"/>
       <circle cx="34" cy="90" r="10" fill="#1E293B" stroke="#fff" stroke-width="4"/>
       <circle cx="92" cy="90" r="10" fill="#1E293B" stroke="#fff" stroke-width="4"/>
       <rect x="22" y="52" width="20" height="14" rx="2" fill="#E0F2FE"/>`,
    ),
  },
  {
    id: 'check-seal',
    label: 'تایید',
    size: 128,
    svg: wrap(
      128,
      `<circle cx="64" cy="64" r="46" fill="#22C55E" stroke="#fff" stroke-width="6"/>
       <path d="M40 66l16 16 32-36" stroke="#fff" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>`,
    ),
  },
  {
    id: 'arrow-down-cta',
    label: 'فلش پایین',
    size: 128,
    svg: wrap(
      128,
      `<path d="M64 18v70" stroke="#fff" stroke-width="14" stroke-linecap="round"/>
       <path d="M64 18v70" stroke="#F43F5E" stroke-width="8" stroke-linecap="round"/>
       <path d="M32 70l32 36 32-36" stroke="#F43F5E" stroke-width="12" stroke-linecap="round" stroke-linejoin="round"/>`,
    ),
  },
];

export function stickerDataUrl(sticker: StickerKind): string {
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(sticker.svg)}`;
}

export function findSticker(id: string): StickerKind | undefined {
  return HEADER_STICKERS.find((s) => s.id === id);
}
